import { useEffect, useState } from "react"

import { APPLE_CLIENT_ID } from "api/api.config"
import { IAppleLoginPayload } from "api/reactQuery/mutations/appleLogin.types"

interface IProps {
  mutate: (payload: IAppleLoginPayload) => void
}

export const useApple = ({ mutate }: IProps) => {
  const [loadedApple, setLoadedApple] = useState(false)

  useEffect(() => {
    let attempts = 0
    const maxAttempts = 50 // 5 seconds
    const check = setInterval(() => {
      attempts++
      if (window.AppleID) {
        setLoadedApple(true)
        clearInterval(check)
      } else if (attempts >= maxAttempts) {
        clearInterval(check)
      }
    }, 100)

    return () => clearInterval(check)
  }, [])

  useEffect(() => {
    if (!loadedApple || !window.AppleID) return

    window.AppleID.auth.init({
      clientId: APPLE_CLIENT_ID,
      scope: "name email",
      redirectURI: window.location.origin,
      usePopup: true,
    })
  }, [loadedApple])

  const signIn = async () => {
    if (!window.AppleID) return

    try {
      const response = await window.AppleID.auth.signIn()
      const code = response.authorization?.code
      if (!code) {
        throw new Error("Apple Sign-In response missing authorization code")
      }
      const payload: IAppleLoginPayload = {
        code,
        redirect_uri: window.location.origin,
      }

      const firstName = response.user?.name?.firstName
      const lastName = response.user?.name?.lastName
      if (firstName) payload.first_name = firstName
      if (lastName) payload.last_name = lastName

      mutate(payload)
    } catch {
      // user cancelled or popup closed — no action needed
    }
  }

  return { signIn, loadedApple }
}
